import Spinner from 'react-bootstrap/Spinner';
import {Modal, Row, Col,Button, Card, Form} from 'react-bootstrap'
import DataTable from  '../DataTable/DataTable';
import { useEffect, useState,useRef } from 'react';
import { Navigate } from "react-router-dom";
import Layout from '../../layout/default';
import { Icon, CustomDropdownToggle, CustomDropdownMenu, LinkList, LinkListItem, Rating, DateRangePicker } from "..";
import { Dropdown } from "react-bootstrap";
import { Block, BlockHead, BlockHeadBetween, BlockHeadContent} from '..';
import { Alert } from 'react-bootstrap';
import { right } from '@popperjs/core';
import InvoiceDetail from './InvoiceDetail';
import { Link } from 'react-router-dom';
import { Data } from '@react-google-maps/api';
import { useApiClient } from '../../ApiService/useApiClient';

// const baseURL = SiteConfig.API_BASE_URL + "HMCareInvoice/invoicelist/C1010201183240/";
const baseURL = "HMCareInvoice/invoicelist/";

const pagetitle = "Invoices";
const pagetitleAddNew = "Create New Invoice";
const pagetitleUpdate = "Update";


const InvoiceList = ({CustomerID}) => {

    const api = useApiClient();

    const dataFetchedRef = useRef(false);

    const [DatatoUse, setData] = useState(null);
    const [error, setError] = useState(null);
  
    const modalForm = useRef(null);
    const modalFormAdd = useRef(null);
    const [selectedData, setSelectedData] = useState([]);
    const [previewModal, setPreviewModal] = useState(false);
    const [AddModal, setAddModal] = useState(false);
    const [refresh, setRefresh] = useState(false);
    


    const tableColumns = [
        {
          name: "Invoice #",
          selector: (row) => 
            {
                return <Link onClick={()=>{detailSelect(row)}} >INV00{row.invoiceId}</Link>;
            }                
        ,
          sortable: false,
          //hide : "lg",
          //omit : true,
    
        },
        
        // {
        //     name: "name",
        //     selector: (row) => row.firstName +' '+ row.lastName,
        //     sortable: true,                        
        // },
        {
            name: "Invoice Date",
            selector: (row) => new Date(row.invoiceDate).toLocaleString(),
            sortable: true,                
        },    
        {
            name: "Invoice Total",
            selector: (row) => '£'+ row.invoiceTotal?.toFixed(2),
            sortable: true,                
        }, 
        {
           // accessor: 'caseId',
           // name: 'Case Id',
            selector: (row) => {
              const  value  = row.invoiceId;
              return <><Button variant="outline-primary" size='sm' onClick={()=>{detailSelect(row)}}><Icon name="eye-alt-fill"></Icon>&nbsp;View</Button> 
              {/* <Button variant="outline-danger" size='sm' onClick={()=>{alert(row.invoiceId)}}><Icon name="file-download"></Icon>&nbsp;PDF</Button> */}
                </>        
            },
          },
        
    ]

    //console.log("=============");
    //console.log(baseURL+CustomerID+"/");
    
    useEffect(()=> {

        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
      
        api.get(baseURL+CustomerID+"/")        
        .then((Response)=>{
            setData(Response.data);
        }).catch(error => {
            setError(error);     
            console.log({error})
        });

    },[refresh])

    //console.log (DatatoUse)
    //return

    if (error) 
        {      
          if(error.message.indexOf("status code 401")){
            return <Navigate to="/auths/auth-login" />
          } else
          return "Error: ${error.message}";
        }
    
        if(!DatatoUse) return(
            
                <Spinner animation="border" variant="primary" />
                
        );

       //console.log(DatatoUse);

function detailSelect(obj){

 //   console.log(obj);

    const currentData = obj // {...selectedData, obj,  }
  
    setSelectedData(currentData)
    setPreviewModal(true) 

    }



function closePreviewModal(){
    setPreviewModal(false);
    } 

function closeAddModal(){
    setAddModal(false);
    } 

function openAddModel(){
    setAddModal(true);
    } 
    

const updateState = (updatedData) => {

    const newState = DatatoUse.map(obj => {
        // 👇️ if id equals 2, update country property
        if (obj.id === updatedData.id) {
        return {...obj, regionName: updatedData.regionName};
        }

        // 👇️ otherwise return the object as is
        return obj;
    });
    
    setData(newState);
    
    };

    function handleAddFormSubmit(event){

        event.preventDefault();
        let newName = modalForm.current.querySelector('#dataname').value;
        console.log(newName);

        let StartDate = modalForm.current.querySelector('#start').value; 
        let endDate = modalForm.current.querySelector('#end').value; 
        
        const frmFormData = new FormData();        
        frmFormData.append("fromdate", StartDate) 
        frmFormData.append("todate", endDate) 
        frmFormData.append("CustomerID", CustomerID) 
        
      
        const sURL = "HMCareInvoice/create/";
       
        api.post(sURL,frmFormData)
        .then((Response)=>{

            let updatedDataObj = Response.data;       

            dataFetchedRef.current = false;     
            setRefresh(!refresh);
                      
        }).catch(error => {
            setError(error);     
            console.log({error})
        });

        setAddModal(false);

    }   

    
  return (

    <>    
    <Block.Head page className="wide-lg">    
        <BlockHeadContent className="tools">  
            <Button size='sm'  variant="outline-primary" action="add" onClick={openAddModel}>
                <Icon name="plus"></Icon><span>{pagetitleAddNew}</span>
            </Button>
        </BlockHeadContent>          
        <Block.Text>            
            <DataTable 
                tableClassName="data-table-head-light table-responsive" 
                pointerOnHover={true} 
                data={DatatoUse}                     
                columns={tableColumns} 
                striped={true} 
                highlightOnHover={true}  
                filterFieldName="customerId" 
                //onRowClicked={(row,event)=>{ detailSelect(row)}}            
                actions="export"             
            />
        </Block.Text>
    </Block.Head>    
              
   

{selectedData && 
    <Modal size="lg" show={previewModal} onHide={closePreviewModal} backdrop="static" >
        <Modal.Header closeButton>
            <Modal.Title className="event-title" as="h4">Invoice INV00{selectedData.invoiceId}</Modal.Title>  
        </Modal.Header>
        <Modal.Body>
            <InvoiceDetail invoiceId={selectedData.invoiceId} />  
        </Modal.Body>
        <Modal.Footer>
            <Button variant="outline-secondary" onClick={closePreviewModal}>X Close</Button>        
        </Modal.Footer>
    </Modal>
}

<Modal show={AddModal} onHide={closeAddModal}>
<Modal.Header closeButton>
  <Modal.Title className="event-title" as="h4">Create New Invoice</Modal.Title>  
</Modal.Header>

<Form ref={modalForm} onSubmit={handleAddFormSubmit}>
<Modal.Body>
  <div>
    <Row className="g-3">       
        <Col xs="12">
            <Form.Group>
                <Form.Label htmlFor="eventTitle">Invoice #</Form.Label>
                <div className="form-control-wrap">
                    <Form.Control id="dataname" type="text" defaultValue={''} placeholder="Value" />
                </div>                
            </Form.Group>
            <br></br>
            <Form.Group>
            <Form.Label htmlFor="eventTitle">Dates</Form.Label>
                <DateRangePicker/>
            </Form.Group>
        </Col>        
    </Row>
  </div>
</Modal.Body>
<Modal.Footer>
    <Button variant="primary" type="submit">Create</Button>
</Modal.Footer>
</Form>
</Modal>

</>
  )
}

export default InvoiceList